import React, { useState } from 'react'
import './styles.scss'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'
import DataWrapperChart from '../DataWrapperChart'

export const HospChart = () => {
  const [isCurrentWave, setCurrentWave] = useState<boolean>(true)

  return (
    <div className='graphic chart' id='hospToggle'>
      <h3>Hospitalisierte in der Schweiz nach Altersgruppen</h3>
      <div className='toggleWrapper'>
        <div className='center'>
          <div className={'label ' + (!isCurrentWave ? '' : 'off')}>Total</div>
          <div className='toggleContainer'>
            <Toggle
              defaultChecked={isCurrentWave}
              icons={false}
              onChange={() => {
                setCurrentWave(!isCurrentWave)
              }}
            />
          </div>
          <div className={'label right ' + (isCurrentWave ? '' : 'off')}>
            4. Welle (ab 28. Juni)
          </div>
        </div>
      </div>

      <div
        className='switchMap'
        style={{ position: 'relative', display: 'block' }}
      >
        <div
          style={{
            opacity: !isCurrentWave ? '0' : '1.0',
            position: 'absolute',
            top: '0',
            zIndex: !isCurrentWave ? 1 : 99,
            width: '100%'
          }}
        >
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/IFLAG/'
            // style={{ height: '680px' }}
          />
          {/* <DataWrapperChart chartId='IFLAG' height={504} /> */}
        </div>
        <div
          style={{
            opacity: isCurrentWave ? '0' : '1.0',
            position: 'relative',
            top: '0',
            zIndex: !isCurrentWave ? 99 : 1,
            width: '100%'
          }}
        >
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/bio7V/'
            // style={{ height: '680px' }}
          />
          {/* <DataWrapperChart chartId='bio7V' height={504} /> */}
        </div>
      </div>
    </div>
  )
}
